import Backbone from 'backbone'
import template from './advanced-permissions-form.hbs'
import constants from 'scoreboard/components/constants'
import _ from 'lodash'
import $ from 'jquery'
import config from 'scoreboard/components/config'
import permissions from 'scoreboard/components/permissions'
import license from 'scoreboard/components/license'
import ToggleAllCheckboxes from 'scoreboard/components/toggle-all-checkboxes'
import ConditionalCheckboxToggle from 'scoreboard/components/conditional-checkbox-toggle'
import Group from './group'
import {permissionLabels} from '../../../components/permissions-metadata'

/**
 * Ensures the checkboxes with the given values are checked
 * @param elements a jQuery object referring to all possible checkboxes to work with
 * @param values an array of values to match with inputs
 */
function writeCheckboxes(elements, values) {
	var set = _.transform(values, function(result, value) {
		result[value] = true
	})
	elements.each(function(i, el) {
		if (set[el.value]) {
			el.checked = true
		}
	})
}

/**
 * Returns an array of the values of the checkboxes that are checked
 * @param elements the checkboxes to examine
 * @returns an Array of the values of all the checked checkboxes
 */
function readCheckboxes(elements) {
	return elements.filter('[value]:visible:checked').map(function(index, el) {
		return parseInt(el.value)
	}).get()
}

var AdvancedPermissions = Backbone.View.extend({

	/** @type {Group|OrganizationTemplatePermission} */
	model: null,

	// this.options.type is the currently chosen group type

	tagName: 'form',

	className: 'advanced-permissions-form',

	events: {
		'submit': 'submit',
		'change input[type=checkbox]': 'setDirty',
		'change [name=sqlConsole]': 'toggleWarning',
		'click .select-default': 'selectDefault',
		'click .unselect-all': 'unselectAll',
		'click .modify-users' : 'toggleDeleteUsers',
		'click .delete-users' : 'toggleModifyUsers',
		'click .archive-initiatives': 'toggleEditInitiatives',
		'click .edit-initiatives': 'toggleArchiveInitiatives',
		'change [name=modifyAllDatasets]': 'onChangeModifyAllDatasets',
		'change [name=modifyStandardPermissionDatasets]': 'onChangeModifyStandardPermissionDatasets',
		'change [name=modifyDatasetRecords]': 'onChangeModifyDatasetRecords',
		'change [name=viewDatasetRecordsTab]': 'onChangeViewDatasetRecordsTab',
	},

	/**
	 *
	 * @param {Object} options
	 *
	 * @param {GroupType} options.type the currently chosen group type
	 *
	 * @param {Int[]|String[]} [options.disabledPermissionIds] an array of permission ids
	 * (eg constants.SEC_CODE_VIEWALLORGNODES) that should be disabled
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
			// e.g. add a "viewers" class so we can control which checkboxes
			// are displayed
			.addClass(this.options.type)
			.addClass(`license-model-${license.licenseModel}`)
			.toggleClass(`unlimited-active-viewers`, license.licenseModel == 'scoreboard' && license.activeViewers < 0)

		// #30565 needs to be before we apply any default checkbox state,
		// so that any trickle down behavior from parent permissions can
		// propagate to child rolls/checkboxes, under that section,
		// via toggle all behavior

		// #32948 moving panels around/between columns temporarily removes panels
		// from handlebars so needs to be done and finalized before writing the checkboxes
		this.adjustColumnDisplay()

		this.toggleAllCheckboxesViews = _.map(this.$('.panel'), (panel) => {
			let tac = new ToggleAllCheckboxes({
				el: panel
			}).render()

			this.listenTo(tac, 'change', () => {
				this.secure()
			})

			if (tac.$('input[type=checkbox][name=sqlConsole]').length > 0) {
				this.listenTo(tac, 'toggleAll', checked => {
					this.toggleWarning()
				})
			}

			return tac
		})

		writeCheckboxes(this.$('input[type=checkbox]'), this.model.get('permissionIds'))
		this.setupDatasetToggles()

		// #11158 #11470 only select default if permissions aren't specified on
		// the model yet, and this is a new group
		if (this.model.isNew() && _.isNil(this.model.get('permissionIds'))) {
			this.selectDefault()
		}
		this.secure()
		// Some last-child list-items are hidden, so we need to remove the bottom border
		// of the last visible item, not just the `li:last-child`
		// Note that `:visible` & `:last` (not :last-child) are jquery selectors not available in css
		this.$('.list').find('li:visible:last').css('border-bottom', '0')

		// #30957 If panel or input not displayed, remove it from handlebars to
		// avoid UI issues
		this.$('li').filter('.is-not-displayed').remove()
		this.$('.panel').filter('.is-not-displayed').remove()

		this.toggleAllCheckboxesViews.forEach(checkboxView =>{
			checkboxView.toggleToggleCheckbox()
		})

		this.toggleDatasetToggles()
		this.toggleWarning()

		// #54348 when the select/deselect all is toggled on the dataset panel,
		// update the panel so the appropriate options are enabled/disabled
		const datasetToggleAllView = _.find(this.toggleAllCheckboxesViews,
			tav => tav.$el.hasClass('datasets'))
		this.listenTo(datasetToggleAllView, 'toggleAll', () =>
			this.toggleDatasetToggles())

		return this
	},

	setupDatasetToggles: function () {
		const modStdCssSel = '[name=modifyStandardPermissionDatasets]'
		const subjectsCssSel = '[name=modifyDatasetRecords], [name=viewDatasetRecords], [name=viewDatasetRecordsTab], [name=modifyDatasetViews]'
		this.datasetToggles = new ConditionalCheckboxToggle({el: this.$('.datasets')})
		this.datasetToggles.addRelation('modifyAllDatasets', this.$(`${modStdCssSel}, ${subjectsCssSel}`))
		this.datasetToggles.addRelation('modifyStandardPermissionDatasets', this.$(subjectsCssSel))
		this.datasetToggles.addRelation('modifyDatasetRecords', this.$('[name=viewDatasetRecords]'))
		this.datasetToggles.addRelation('viewDatasetRecordsTab', this.$('[name=viewDatasetRecords]'))
	},

	// #34573 toggle initial enabled/disabled states for this.datasetToggles checkboxes
	toggleDatasetToggles: function() {
		this.onChangeModifyAllDatasets()
		this.onChangeModifyStandardPermissionDatasets()
		this.onChangeModifyDatasetRecords()
		this.onChangeViewDatasetRecordsTab()
	},

	onChangeModifyAllDatasets: function() {
		this.datasetToggles.toggle('modifyAllDatasets')
		this.onChangeModifyStandardPermissionDatasets()
	},

	onChangeModifyStandardPermissionDatasets: function() {
		this.datasetToggles.toggle('modifyStandardPermissionDatasets')
		this.onChangeModifyDatasetRecords()
	},

	onChangeModifyDatasetRecords: function() {
		this.datasetToggles.toggle('modifyDatasetRecords')

		// ensure that the 'viewDatasetRecords' checkbox is disabled
		// if 'viewDatasetRecordsTab' is checked
		if (this.$('[name=viewDatasetRecordsTab]').prop('checked')) {
			this.$('[name=viewDatasetRecords]').prop('disabled', true)
		}
	},

	onChangeViewDatasetRecordsTab: function() {
		this.datasetToggles.toggle('viewDatasetRecordsTab')

		// ensure that the 'viewDatasetRecords' checkbox is disabled
		// if 'modifyDatasetRecords' is checked
		if (this.$('[name=modifyDatasetRecords]').prop('checked')) {
			this.$('[name=viewDatasetRecords]').prop('disabled', true)
		}
	},

	context: function() {
		// #30037 use "dashboards and strategy maps" if strategy maps are enabled
		// #33124 Panel title should also appropriately change
		let dashboardsPanelTitle = 'dashboards.dashboards'
		if (config.displayStrategyMaps) {
			dashboardsPanelTitle = 'admin.group.category.dashboardsAndStrategyMaps'
		}
		return {
			principal: this.model.attributes,
			constants: constants,
			modifyDashboards: permissionLabels()[constants.SEC_CODE_MODIFYDASHBOARDS],
			modifySharedDashboards: permissionLabels()[constants.SEC_CODE_MODIFYEMBEDDEDDASHBOARDS],
			dashboardsPanelTitle,
			rollupTreeGroupLabel: this.options?.rollupTreeGroup?.label,
		}
	},

	disabledPermission (permissionId) {
		return !_.isNil(_.find(this.options.disabledPermissionIds, id => {
			// Use loose equals because the checkbox values are strings
			return id == permissionId
		}))
	},

	// note: restricting available permissions by group type is done in the CSS
	secure: function() {
		_.each(this.$('input[type=checkbox][value]'), function(checkbox) {
			let permissionId = checkbox.value

			if (!permissions.general[permissionId]) {
				// #7303 only allow assigning permissions that you have
				this.$(checkbox).closest('li').addClass('is-not-displayed')
			}

			if (this.disabledPermission(permissionId)) {
				// Disable and uncheck any permissions that should be disabled
				this.$(checkbox)
					.prop('checked', false)
					.prop('disabled', true)
			}
		}.bind(this))

		// hide any panels that no longer have anything within them
		_.each(this.$('.panel'), function(panel) {
			panel = this.$(panel)
			var hide = panel.find('li:visible').length == 0
			panel.toggleClass('is-not-displayed', hide)
		}.bind(this))


		// note: with #48947, license.forms is based on license.datasets
		let features = ['datasets', 'initiatives', 'reports', 'files', 'forms']
		_.each(features, feature => {
			if (!license[feature]) {
				this.$(`.${feature}`).addClass('is-not-displayed')
			}
		})

		this.$('.dashboards-maps').not('.is-not-displayed')
			.toggleClass('is-not-displayed', !license.dashboards)
		this.$('.modify-scorecard-overview').not('.is-not-displayed')
			.toggleClass('is-not-displayed', !license.scorecards)

		if (!config.enableProjects) {
			this.$(`input[type=checkbox][value=${constants.SEC_CODE_MODIFYPROJECTS}]`)
				.closest('li').remove()
		}
	},

	getPermissionIds: function() {
		return readCheckboxes(this.$('input[type=checkbox]'))
	},

	submit: function() {
		this.model.set('permissionIds', this.getPermissionIds())
		this.trigger('done', this.dirty)

		// don't refresh the browser
		return false
	},

	setDirty: function(dirty) {
		this.dirty = _.isNil(dirty) ? true : dirty
	},

	toggleWarning: function(e) {
		let sqlCheckbox = e && this.$(e.currentTarget) || this.$('[name=sqlConsole]')
		let showWarning = sqlCheckbox.is(':checked')
		this.$('.sql-console-warning').toggleClass('is-not-displayed', !showWarning)
	},

	selectDefault: function() {
		this.setDirty()
		this.$('input[type=checkbox]').prop('checked', true)
		var uncheck = [ 'serverAdmin', 'allGroups', 'sqlConsole',
			'modifyAllDatasets', 'importConnectionsModify', 'projectsModify',
			// superAdmin and other are category headings
			'superAdmin', 'other' ]
		if (config.sms) {
			uncheck.push('viewAllOrgs', 'calendarsModify', 'applicationConfigure',
				'importsModify', 'modifySharedDashboards', 'modifySharedForms',
				'modifyScheduledExports')
			// #34995 'Local Administrators' should have 'Modify View Organization Permissions'
			// checked by default (reverts #20622)
		}
		if (this.options.type === 'updaters') {
			// #55868
			// 'modifyStandardPermissionDatasets' needs to be unchecked so that
			// it does not lock other dataset checkboxes when it is not visible.
			// 'modifyDatasetViews' is unchecked because it is not visible
			// and checked by default
			uncheck.push('updateAllMetrics', 'updateAllThresholds',
				'modifyStandardPermissionDatasets', 'modifyDatasetViews')
		}
		_.each(uncheck, function(name) {
			this.$('input[name=' + name + ']').prop('checked', false)
		}.bind(this))

		// #20623 ensure each category heading checkbox is toggled
		// appropriately after defaults are selected
		_.each(this.toggleAllCheckboxesViews, (toggleView) => {
			toggleView.toggleToggleCheckbox()
		})

		// #54348 when default options are selected, make sure the appropriate
		// checkboxes are enabled/disabled in the datasets panel
		this.toggleDatasetToggles()

		// #55869
		// After selecting default options, ensure we aren't enabling
		// permissions that are passed into options as disabled permissions IDs
		this.secure()
	},

	unselectAll: function() {
		this.setDirty()
		this.$('input[type=checkbox]').prop('checked', false).change()
	},

	toggleDeleteUsers : function() {
		if (!this.$('.modify-users').prop('checked')) {
			this.$('.delete-users').prop('checked', false)
		}
	},

	toggleModifyUsers : function() {
		if (this.$('.delete-users').prop('checked')) {
			this.$('.modify-users').prop('checked', true)
		}
	},

	toggleEditInitiatives: function () {
		if (this.$('input.archive-initiatives').prop('checked')) {
			this.$('.edit-initiatives').prop('checked', true)
		}
	},

	toggleArchiveInitiatives: function () {
		if (!this.$('edit-initiatives').prop('checked')) {
			this.$('input.archive-initiatives').prop('checked', false)
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.toggleAllCheckboxesViews, this.datasetToggles, 'remove')
	},

	/**
	 * #31041 if group type is updaters/communication users, move the 'other' panel to the middle column
	 * so that only two columns are shown in display
	 */
	adjustColumnDisplay: function() {
		let updatersCheck = this.options.type === 'updaters'
		if (updatersCheck) {
			let otherPanel = this.$('.other')
			let destinationCol = this.$('.middle-col')
			otherPanel.remove()
			destinationCol.append(otherPanel)
		}
	}

})

/**
 * Sets/unsets appropriate permissions based on the group's group type
 * @param {Group} [groupToPrune] if specified, an existing group that should have
 * its permissions pruned based on the group type. If not provided, calling
 * this method sets default permissions for the current group
 */
function setPermissionsForGroupType (principalToUpdate, groupType, groupToPrune) {
	groupToPrune = groupToPrune || new Group()
	// this is weird, but I already coded the logic for what default
	// permissions are in the AdvancedPermissionsForm and I don't want
	// to recode it.
	var form = new AdvancedPermissions({
		// we want to find the default permissions, not examine the
		// permissions on the already existing group
		model: groupToPrune,
		type: groupType
	})
	$('body').append(form.el)
	form.render()
	principalToUpdate.set('permissionIds', form.getPermissionIds())
	form.remove()
}

export default AdvancedPermissions
export { setPermissionsForGroupType }

AdvancedPermissions.__filename__ = 'admin/principals/groups/advanced-permissions-form.js'
